<template>
    <div class="scrollBox">
        <pdf v-for="item in numPages" :key="item" :src="pdfSrc" :page="item" ref="pdf"></pdf>
    </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
    props: ['pdfSrc'],
    components: {
        pdf,
    },
    data() {
        return {

            numPages: null, // pdf 总页数
        };
    },
    mounted() {
        this.getNumPages();
    },
    methods: {
        // # 计算pdf页码总数
        getNumPages() {
            let loadingTask = pdf.createLoadingTask(this.pdfSrc);
            loadingTask.promise
                .then((pdf) => {
                    this.numPages = pdf.numPages;
                })
                .catch((err) => {
                    console.error("pdf 加载失败", err);
                });
        },
    },
    created() { },
};
</script>
<style>
.scrollBox {
    width: 100%;
    height: 700px;
}
</style>
